import script from "./PasswordResetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetPage.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetPage.vue?vue&type=style&index=0&id=28990574&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28990574"]])

export default __exports__